import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Retails from "./Retails";
import AppHeader from "components/Header/AppHeader";
import MDBox from "components/MDBox";

function RetailsNetworkPage({ subcategoryToken }) {
  return (
    <DashboardLayout>
      <MDBox
             sx={{
               display: {
                 xs: "block",
                 sm: "block",
                 md: "none",
               },
             }}
           >
             <AppHeader />
           </MDBox>
      <Retails subcategoryToken={subcategoryToken} />
    </DashboardLayout>
  );
}

export default RetailsNetworkPage;
